export const IconMix = () => {
  const pixelSize = 24;

  return (
    <svg
      width={pixelSize}
      height={pixelSize}
      viewBox={`0 0 ${pixelSize} ${pixelSize}`}
    >
      <path
        d="M12 7.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9zM5.5 12a6.5 6.5 0 1 1 13 0 6.5 6.5 0 0 1-13 0zM11 3V0h2v3h-2zm0 21v-3h2v3h-2zm6.657-19.071 2.121-2.121 1.415 1.414-2.122 2.121-1.414-1.414zM2.808 19.778l2.12-2.121 1.415 1.414-2.121 2.121-1.414-1.414zM21 11h3v2h-3v-2zM0 11h3v2H0v-2zm19.071 6.657 2.121 2.121-1.414 1.415-2.121-2.122 1.414-1.414zM4.222 2.808l2.121 2.121L4.93 6.343 2.808 4.222l1.414-1.414z"
        fill="currentColor"
      />
    </svg>
  );
};
